module.exports = __webpack_public_path__ + "static/media/swipe.78435b18.gif";